import { render, staticRenderFns } from "./TaskArchiveModal.vue?vue&type=template&id=b6a73d7e&scoped=true"
import script from "./TaskArchiveModal.vue?vue&type=script&lang=js"
export * from "./TaskArchiveModal.vue?vue&type=script&lang=js"
import style0 from "./TaskArchiveModal.vue?vue&type=style&index=0&id=b6a73d7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a73d7e",
  null
  
)

export default component.exports